import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';
import { FormControl } from '@angular/forms';

import { FilterInterface } from '../../../shared/filter-bar/filter-bar.component';
import { DashboardType, GetConversionRatesGQL, GetConversionsGQL } from '../../../../generated/graphql';
import { StandupDashboardServiceService } from '../standup-dashboard-service.service';
import { RelayIdService } from '../../../shared/relay-id.service';

@Component({
  selector: 'app-conversion-rates-transregional',
  templateUrl: './conversion-rates-transregional.component.html',
  styleUrls: ['./conversion-rates-transregional.component.scss']
})
export class ConversionRatesTransregionalComponent implements OnInit {
  CONVERSION_KEY_MAP = {
    initial_to_interested: 'CONVERSIONS.INITIAL_TO_INTERESTED',
    interested_to_interview: 'CONVERSIONS.INTERESTED_TO_INTERVIEW',
    interview_to_presented: 'CONVERSIONS.INTERVIEW_TO_PRESENTED',
    presented_to_client_interview: 'CONVERSIONS.PRESENTED_TO_CLIENT_INTERVIEW',
    client_interview_to_health_check: 'CONVERSIONS.CLIENT_INTERVIEW_TO_HEALTH_CHECK',
    health_check_to_employed: 'CONVERSIONS.HEALTH_CHECK_TO_EMPLOYED'
  };

  conversionsSet = {};
  dataSource = [];
  filterCache: FilterInterface;
  isLoading = true;
  initDates: FilterInterface;
  dateFilter = new FormControl(null);
  columnsToDisplay = [];

  @Input() dashboardTitle;
  @Input() card;
  @Input() dashboardItem: DashboardType;

  constructor(
    private getConversionRatesGQL: GetConversionRatesGQL
  ) { }

  ngOnInit(): void {
    this.dateFilter.valueChanges.subscribe(value => {
      if (value) {
        this.loadConversions(moment(value).format('YYYY-MM-DD'));
      }
    });
    this.dateFilter.setValue(moment());
  }

  // onFilterChanges(filters: FilterInterface): void {
  //   const dateRange = filters.dateRange;
  //   const cachedRange = this.filterCache?.dateRange;
  //
  //   this.isDatePickerClosed = !!(
  //     !this.filterCache || (dateRange.dateFrom.isSame(cachedRange.dateFrom) && (!cachedRange.dateTo && dateRange.dateTo))
  //   );
  //
  //   this.filterCache = filters;
  //
  //   if ((this.isDatePickerClosed) && dateRange && (dateRange.dateFrom && dateRange.dateTo)) {
  //     this.loadConversions(
  //       dateRange.dateFrom ? moment(dateRange.dateFrom).format('YYYY-MM-DD') : null,
  //       dateRange.dateTo ? moment(dateRange.dateTo).format('YYYY-MM-DD') : null
  //     );
  //   }
  // }

  private loadConversions(date): void {
    if (!this.card?.id) {
      return;
    }

    this.columnsToDisplay = [];
    this.conversionsSet = {};
    this.dataSource = [];

    this.isLoading = true;

    // this.getConversionsGQL.fetch({id: this.card.id, dateTo, dateFrom, dashboardRegion: null}).subscribe((metricGroups) => {
    //
    //   this.isLoading = false;
    // }, e => this.isLoading = false);
    this.getConversionRatesGQL
      .fetch({cardId: this.card.id, dashboardId: this.dashboardItem.id, date})
        .subscribe(v => {
          const data = v.data.conversionRatesTransregional;
          const rawColumns = [];
          data.forEach((r, i) => {
            this.conversionsSet[r.regionGroupId] = {
              ...this.conversionsSet[r.regionGroupId],
              region: r.regionGroup.title,
              [r.conversionType]: r.ordersBelowAverageCount
            };
            rawColumns.push(r.conversionType);
          });
          Object.keys(this.conversionsSet).forEach(name => {
            this.dataSource.push(this.conversionsSet[name]);
          });
          this.columnsToDisplay = Array.from(new Set(rawColumns));
          if (this.columnsToDisplay.length) {
            this.columnsToDisplay.unshift('region');
          }
          this.isLoading = false;
        }, e => this.isLoading = false);
  }

  getColValue(item) {
    return typeof item === 'number' || typeof item === 'string' ? item : '-';
  }
}
